import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IRule } from '@/types/newSetup.type';

interface IPreviewState {
  selectedRule?: IRule;
  selectedLanguage?: string;
  selectedCountry?: string;
  selectedFlag?: string;
  selectedZipcode?: string;
}

const initialState: IPreviewState = {
  selectedRule: undefined,
  selectedLanguage: undefined,
};

export const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    handleUpdateSelectedRule: (state, action: PayloadAction<IRule | undefined>) => {
      state.selectedRule = action.payload;
    },
    handleSetSelectedLanguage: (state, action: PayloadAction<string | undefined>) => {
      state.selectedLanguage = action.payload;
    },
    handleSetSelectedCountry: (state, action: PayloadAction<{ country?: string; flag?: string } | undefined>) => {
      if (!action.payload) {
        state.selectedCountry = undefined;
        state.selectedFlag = undefined;
      } else {
        const { country, flag } = action.payload;
        state.selectedCountry = country;
        state.selectedFlag = flag;
      }
    },
    handleSelectedZipcode: (state, action: PayloadAction<string | undefined>) => {
      state.selectedZipcode = action.payload;
    },
  },
});

export const selectedRuleSelector = createSelector(
  (state: RootState) => state.preview.selectedRule,
  (state) => state,
);

export const selectedLanguageSelector = createSelector(
  (state: RootState) => state.preview.selectedLanguage,
  (state) => state,
);

export const selectedCountrySelector = createSelector(
  (state: RootState) => state.preview.selectedCountry,
  (state) => state,
);

export const selectedFlagSelector = createSelector(
  (state: RootState) => state.preview.selectedFlag,
  (state) => state,
);

export const selectedZipcodeSelector = createSelector(
  (state: RootState) => state.preview.selectedZipcode,
  (state) => state,
);

export default previewSlice;
